import React from 'react'
import {Row, Col} from 'components/Display'
import UserAvatar from 'components/UserAvatar'
import TextArea from 'components/TextArea'
import Button from 'components/Button'
import {useForm} from 'utils/hooks/form'
import {usePublished} from 'utils/published'
import services from 'services'
import {useFunction} from 'utils/hooks/function'
import ReactTooltip from 'react-tooltip'

type CommentInputProps = {
  threadId: string
}

export default function CommentInput(props: CommentInputProps) {
  const user = usePublished(services.getAuthService().user)
  const service = services.getChatService(props.threadId)
  const sendMessage = useFunction(service.post)

  const textarea = useForm({
    text: '',
  })

  // Grow textarea when user press enter (breakline)
  const textRowCount = textarea.state.text ? textarea.state.text.split('\n').length : 1
  const rows = textRowCount + 1

  return (
    <Row className="flex-1 items-start bg-blue-itx-light py-4 px-8 border-t shadow-2xl">
      <Col>{user && <UserAvatar user={user} />}</Col>

      <Col className="w-full border bg-white ml-4 rounded">
        <form onSubmit={(e) => e.preventDefault()}>
          <Row className="flex-1 pl-3">
            <TextArea
              placeholder={'Write a comment here...'}
              type="textarea"
              className={`resize-none border-none text-sm font-normal w-full py-2 outline-none`}
              rows={rows}
              wrap="hard"
              cols={2}
              value={textarea.state.text}
              onChange={(value) => {
                textarea.update('text', value)
              }}
            />
          </Row>
          <Row className="justify-between items-center px-3 py-3 ">
            <Row>{/* TODO add functionality, Bold/italic/Underline buttons */}</Row>
            <Row>
              <div data-for="EnterToSubmit" data-tip="Tab + Enter to submit">
                <Button
                  disabled={!!!textarea.state.text || sendMessage.isRunning}
                  loading={sendMessage.isRunning}
                  content="Comment"
                  className="bg-itx-primary-4 hover:bg-itx-primary-3 text-white border-none"
                  onClick={() => {
                    sendMessage({text: textarea.state.text}).then(() => textarea.clear())
                  }}
                />
                <ReactTooltip id="EnterToSubmit" effect="solid" />
              </div>
            </Row>
          </Row>
        </form>
      </Col>
    </Row>
  )
}
